<style lang="scss" scoped>
/* 导入按钮（对齐项目导入按钮风格） */
.asset-import {
    display: inline-block;
}

.asset-import-actions {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 8px;
    max-width: 100%;

    .el-upload {
        display: inline-flex;
    }
}
</style>

<style lang="scss">
/* append-to-body 弹窗脱离组件作用域：宽度由 c-el-dialog(96%) 自适应，修饰类单独封顶 */
.asset-dialog--import { max-width: 760px; }
</style>

<template>
    <span class="asset-import">
        <span class="asset-import-actions">
            <el-upload action="#" accept=".json,application/json" :http-request="upload" :show-file-list="false" :disabled="busy">
                <el-button type="warning" size="medium" :loading="busy"><i class="fa fa-sign-in"></i> {{ label }}</el-button>
            </el-upload>
        </span>
        <el-dialog title="导入结果" :visible.sync="visible" append-to-body custom-class="c-el-dialog asset-dialog asset-dialog--import">
            <template v-if="result">
                <p>批次：{{ result.batchId }}</p>
                <p>总数 {{ result.totalCount }} · 新增 {{ result.addedCount }} · 更新 {{ result.updatedCount }} · 跳过 {{ result.skippedCount }} · 错误 {{ result.errorCount }} · 并行绑定 {{ result.parallelCount }}</p>
                <el-table :data="result.errors || []" style="width: 100%" max-height="400" border size="small" empty-text="无导入错误">
                    <el-table-column prop="row" label="行号" width="80" />
                    <el-table-column prop="message" label="错误原因" min-width="300" />
                </el-table>
            </template>
            <span slot="footer"><el-button @click="visible = false">关闭</el-button></span>
        </el-dialog>
    </span>
</template>

<script>
    // JSON 导入按钮 + 导入结果弹窗
    export default {
        props: {
            handler: { type: Function, required: true },
            label: { type: String, default: '导入 JSON' }
        },
        data: () => ({ busy: false, visible: false, result: null }),
        methods: {
            async upload({ file, onSuccess, onError }) {
                if (this.busy) return
                if (!/\.json$/i.test(file.name)) {
                    const error = new Error('请选择 JSON 文件')
                    this.$message.error(error.message)
                    onError(error)
                    return
                }
                this.busy = true
                try {
                    this.result = await this.handler(file)
                    this.visible = true
                    onSuccess(this.result)
                    this.$emit('complete', this.result)
                } catch (error) {
                    onError(error)
                } finally {
                    this.busy = false
                }
            }
        }
    }
</script>
